// publicAnalytics — Phase 1 placeholder event hooks.
//
// Goal: provide a single import surface so every public-site CTA can fire
// named events without committing to a specific analytics vendor yet.
// TODO (Phase 5): wire to Plausible / Segment / Mixpanel.
//
// Today, events forward to the existing /api/events endpoint via the canonical
// lib/analytics.js helper (which already attaches session_id + path).

import { track as baseTrack } from "./analytics";

const isDev = process.env.NODE_ENV !== "production";

// Canonical event names — keep this list authoritative.
export const EVENT = {
  PRODUCT_TOUR_VIEWED:       "public_tour_viewed",
  PRODUCT_TOUR_STARTED:      "public_tour_started",
  PRODUCT_TOUR_COMPLETED:    "public_tour_completed",
  LEARNING_CENTER_VIEWED:    "public_learning_viewed",
  LEARNING_ARTICLE_VIEWED:   "public_learning_article_viewed",
  FAQ_VIEWED:                "public_faq_viewed",
  ASK_AI_OPENED:             "public_ask_ai_opened",
  ASK_AI_PROMPT_SENT:        "public_ask_ai_prompt_sent",
  SAMPLE_REPORT_VIEWED:      "public_sample_report_viewed",
  SAMPLE_REPORT_CTA_CLICKED: "public_sample_report_cta_clicked",
  PRICING_VIEWED:            "public_pricing_viewed",
  STRATEGY_CALL_CLICKED:     "public_strategy_call_clicked",
  PROPOSAL_SERVICES_VIEWED:  "public_proposal_services_viewed",
  STRATEGY_CALL_REQUESTED:   "public_strategy_call_requested",
  DEMO_VIDEO_CLICKED:        "public_demo_video_clicked",
  DEMO_LIBRARY_VIEWED:       "public_demo_library_viewed",
  PERSONALIZED_WALKTHROUGH_CLICKED: "public_personalized_walkthrough_clicked",
  USE_CASE_VIEWED:           "public_use_case_viewed",
  HOW_IT_WORKS_VIEWED:       "public_how_it_works_viewed",
  AI_DISCOVERY_STARTED:      "public_ai_discovery_started",
  AI_DISCOVERY_STEP_COMPLETED: "public_ai_discovery_step_completed",
  AI_DISCOVERY_COMPLETED:    "public_ai_discovery_completed",
  FIT_SUMMARY_GENERATED:     "public_fit_summary_generated",
  LEAD_FORM_SUBMITTED:       "public_lead_form_submitted",
};

export function track(eventName, metadata = {}) {
  if (isDev) {
    // eslint-disable-next-line no-console
    console.debug("[track]", eventName, metadata);
  }
  // Delegate to the canonical analytics helper (handles session_id + path + 422 silencing).
  return baseTrack(eventName, { metadata });
}
